module.exports = __webpack_public_path__ + "static/media/imgDosticsPrincipal.4a208982.jpg";